import { combineReducers } from "redux";
import authReducer from './authReducer/auth.reducer';
import tokenReducer from './tokenReducer/token.reducer';
import empresasReducer from './empresasReducer/empresas.reducer';

const appReducer = combineReducers({
    auth: authReducer,
    token: tokenReducer,
    empresas: empresasReducer
});

const rootReducer = (state: any, action: any) => {
    return appReducer(state, action);
};

export default rootReducer;
